export const categoryData: Record<string, {
  title: string;
  description: string;
  icon: string;
  banner: string;
}> = {
  wanghong: {
    title: '网红黑料',
    description: '头部主播、短视频达人、社交媒体网红的最新爆料与争议事件实时追踪',
    icon: 'ri-fire-line',
    banner: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20dramatic%20scene%2C%20streaming%20studio%20with%20red%20alert%20lights%2C%20cyberpunk%20aesthetic%2C%20dramatic%20contrast%2C%20pink%20neon%20accents%2C%20mysterious%20dark%20atmosphere&width=1600&height=500&seq=cat-banner-wanghong&orientation=landscape',
  },
  mingxing: {
    title: '明星八卦',
    description: '影视明星、歌手、偶像团体的一手八卦与独家内幕消息追踪',
    icon: 'ri-star-line',
    banner: 'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20paparazzi%20flash%20lights%2C%20celebrity%20silhouettes%2C%20glamorous%20entertainment%20atmosphere%2C%20dramatic%20hollywood%20vibe%2C%20dark%20background%20with%20golden%20spotlights&width=1600&height=500&seq=cat-banner-mingxing&orientation=landscape',
  },
  shehui: {
    title: '社会热点',
    description: '社会热点事件、争议话题、公共事件的独家视角与深度追踪报道',
    icon: 'ri-eye-line',
    banner: 'https://readdy.ai/api/search-image?query=Breaking%20news%20journalism%20scene%2C%20press%20conference%20with%20cameras%2C%20dramatic%20newsroom%20lighting%2C%20high%20contrast%20editorial%20style%2C%20urgent%20atmosphere&width=1600&height=500&seq=cat-banner-shehui&orientation=landscape',
  },
  yule: {
    title: '娱乐圈内幕',
    description: '影视综艺、音乐节、颁奖礼等娱乐圈大小事件的幕后真相揭秘',
    icon: 'ri-flashlight-line',
    banner: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20television%20studio%2C%20stage%20equipment%20and%20lights%2C%20dramatic%20backstage%20atmosphere%2C%20entertainment%20industry%20vibe%2C%20dark%20with%20colorful%20stage%20lights&width=1600&height=500&seq=cat-banner-yule&orientation=landscape',
  },
};

export const categoryArticles = [
  {
    id: 1,
    title: '某千万粉丝主播直播间突然被封，背后原因曝光',
    summary: '据知情人士透露，该主播因涉及违规带货被平台永久封禁，累计罚款超千万。多位业内人士分析认为...',
    category: '网红黑料',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20streaming%20studio%20with%20red%20warning%20alert%20on%20computer%20screen%2C%20dark%20atmosphere%2C%20cyberpunk%20aesthetic%2C%20neon%20pink%20accents&width=800&height=600&seq=cat-article-01&orientation=landscape',
    time: '12分钟前',
    reads: '85.2万',
  },
  {
    id: 2,
    title: '顶流女星深夜密会神秘男子，经纪人紧急公关',
    summary: '狗仔拍到某一线女星与圈外男子共进晚餐后同回酒店，工作室连夜发声明否认恋情...',
    category: '明星八卦',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20of%20luxury%20hotel%20entrance%2C%20blurred%20figures%2C%20warm%20golden%20street%20lights&width=800&height=600&seq=cat-article-02&orientation=landscape',
    time: '28分钟前',
    reads: '120.6万',
  },
  {
    id: 3,
    title: '知名综艺录制现场爆发冲突，两位导师当场翻脸',
    summary: '综艺节目录制中途两位评审因选手淘汰问题激烈争执，节目组被迫暂停录制...',
    category: '娱乐圈',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%2C%20dramatic%20red%20and%20blue%20lighting%20contrast&width=800&height=600&seq=cat-article-03&orientation=landscape',
    time: '45分钟前',
    reads: '96.3万',
  },
  {
    id: 4,
    title: '网红品牌被曝使用过期原料，生产线视频流出',
    summary: '某网红自创美妆品牌代工厂内部视频曝光，生产环境令人震惊，品牌方紧急回应称...',
    category: '社会热点',
    tag: '网红黑料',
    image: 'https://readdy.ai/api/search-image?query=Abandoned%20factory%20interior%20with%20dim%20lighting%2C%20industrial%20machinery%2C%20mysterious%20atmosphere&width=800&height=600&seq=cat-article-04&orientation=landscape',
    time: '1小时前',
    reads: '210.8万',
  },
  {
    id: 5,
    title: '吃播大胃王被曝催吐实锤，粉丝集体脱粉回踩',
    summary: '网友在餐厅偶遇某知名吃播，拍到其饭后催吐画面。该主播此前曾多次否认催吐传闻...',
    category: '网红黑料',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20interior%20at%20night%2C%20dramatic%20lighting%2C%20mysterious%20shadows%2C%20suspenseful%20cinematic%20atmosphere&width=800&height=600&seq=cat-article-05&orientation=landscape',
    time: '5小时前',
    reads: '342.7万',
  },
  {
    id: 6,
    title: '热门短剧演员被曝学历造假，多所高校回应未查询到',
    summary: '自称名校毕业的当红短剧演员，被网友扒出学历信息存疑，相关高校教务处均回应...',
    category: '网红黑料',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=University%20diploma%20on%20dark%20desk%20with%20spotlight%2C%20dramatic%20shadow%2C%20mysterious%20investigative%20mood&width=800&height=600&seq=cat-article-06&orientation=landscape',
    time: '3小时前',
    reads: '67.9万',
  },
  {
    id: 7,
    title: '某男团队长恋情曝光，女友竟是圈内知名经纪人',
    summary: '粉丝拍到男团成员与女经纪人牵手逛街，经纪公司回应称系正常同事关系...',
    category: '明星八卦',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Couple%20walking%20hand%20in%20hand%20on%20busy%20shopping%20street%2C%20blurred%20crowd%2C%20warm%20afternoon%20sunlight&width=800&height=600&seq=cat-article-07&orientation=landscape',
    time: '2小时前',
    reads: '178.4万',
  },
  {
    id: 8,
    title: '古装剧女主替身演员曝光行业内幕，剧组待遇引热议',
    summary: '替身演员接受独家专访，揭露剧组对替身演员不公待遇，包括超长工时和极低薪酬...',
    category: '娱乐圈',
    tag: '新瓜',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%2C%20dramatic%20lighting%2C%20movie%20production%20atmosphere%2C%20gritty%20texture&width=800&height=600&seq=cat-article-08&orientation=landscape',
    time: '6小时前',
    reads: '43.5万',
  },
  {
    id: 9,
    title: '网红奶茶品牌加盟商集体维权，总部人去楼空',
    summary: '全国多地加盟商奔赴总部维权，发现公司已搬离注册地址。涉案金额累计超亿元...',
    category: '社会热点',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Protest%20gathering%20outside%20corporate%20building%2C%20dramatic%20crowd%20scene%2C%20tension%20atmosphere%2C%20documentary%20style&width=800&height=600&seq=cat-article-09&orientation=landscape',
    time: '4小时前',
    reads: '189.2万',
  },
  {
    id: 10,
    title: '某卫视跨年晚会阵容泄露，多位一线艺人确认加盟',
    summary: '内部工作人员曝光晚会节目单，包含多位顶流歌手和演员的表演安排细节...',
    category: '娱乐圈',
    tag: '新瓜',
    image: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20colorful%20spotlights%2C%20dramatic%20purple%20and%20gold%20lighting&width=800&height=600&seq=cat-article-10&orientation=landscape',
    time: '4小时前',
    reads: '55.1万',
  },
  {
    id: 11,
    title: '知名歌手演唱会假唱实锤，现场观众上传对比音频',
    summary: '网友对比现场录音与官方音源，发现多处明显对不上。演出主办方尚未回应...',
    category: '明星八卦',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20spotlight%20on%20microphone%2C%20dramatic%20atmosphere%2C%20blue%20and%20pink%20stage%20lighting&width=800&height=600&seq=cat-article-11&orientation=landscape',
    time: '7小时前',
    reads: '278.6万',
  },
  {
    id: 12,
    title: '短视频平台算法被曝光，流量分配存在严重不公',
    summary: '前员工爆料平台内部流量分配机制，头部账号获得流量远超中小创作者数倍...',
    category: '社会热点',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Algorithm%20code%20on%20dark%20screen%2C%20hacker%20aesthetic%2C%20digital%20mystery%2C%20glowing%20text%20on%20black&width=800&height=600&seq=cat-article-12&orientation=landscape',
    time: '8小时前',
    reads: '156.3万',
  },
];